const actions={
    actionsDemo(context){
      return new Promise(resolve => {
        setTimeout(()=>{
          // context上下文，包含mutations等
          context.commit('actionsDemo')
          // 让其变成同步，当然也是需要把actionsDemo提交到mutations里面的
          //  返回最新的数据过后可以在其组件当中一样的使用最新的数据 在其组件直接使用.then(成功)或者.catch(失败)
          resolve(context.state.count)
        },1000)
      } )
    }
  }
  export default actions